import * as React from 'react';
import { cn } from '@/shared/lib/cn';

export type TextareaProps = React.TextareaHTMLAttributes<HTMLTextAreaElement>;

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, ...props }, ref) => {
    return (
      <textarea
        ref={ref}
        className={cn(
          'w-full rounded-[0.5rem] bg-background border border-primary-active-border',
          'px-[0.625rem] py-[0.5rem] text-[0.875rem] text-primary-active-color',
          'transition-all resize-none',
          'disabled:cursor-not-allowed disabled:opacity-50',
          'focus:outline-none',
          'hover:shadow-[0_0_6px_var(--input-glow)]',
          'focus:shadow-[0_0_6px_var(--input-glow)]',
          className,
        )}
        {...props}
      />
    );
  },
);

Textarea.displayName = 'Textarea';

export { Textarea };
